<!-- @veltra/icons generated sha256:f096fce26f70e4fb gen:8 source:src/svg/normal/folder-add.svg -->
<script setup lang="ts">
defineOptions({ name: 'FolderAdd' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M2.5 2a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h5.507a.496.496 0 0 0 .493-.496.5.5 0 0 0-.493-.504H2.5V3h3.104c.105 0 .21.034.294.095l1.808 1.31a.5.5 0 0 0 .296.095H13V8c0 .275.228.5.496.5A.504.504 0 0 0 14 8V4.5a1 1 0 0 0-1-1H8.327a.5.5 0 0 1-.297-.095l-1.808-1.31A.5.5 0 0 0 5.93 2zM12 13v1.49c0 .277.228.51.496.51a.51.51 0 0 0 .504-.51V13h1.49a.51.51 0 0 0 .51-.496.51.51 0 0 0-.51-.504H13v-1.49a.51.51 0 0 0-.496-.51.51.51 0 0 0-.504.51V12h-1.49a.51.51 0 0 0-.51.496c0 .276.234.504.51.504z"
    />
  </svg>
</template>
